module.exports = __webpack_public_path__ + "static/media/thumb-inc.91454ea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/articles/thumb-inc.png
// module id = 235
// module chunks = 0